<div class="d-flex flex-column" [style.gap.rem]="2" *ngIf="form">
  <span class="address-form-label" *ngIf="showTitle" i18n>Head Office Address</span>
  <app-international-address-form-grid
    controlIdPrefix="headOfficeAddress"
    [canadaOnly]="true"
    [threeColumnLayout]="true"
    [form]="form"
    [formSubmitted]="formSubmitted" />
</div>
